import React, { useState } from 'react';
import { Col, Form, InputGroup, Row } from 'react-bootstrap';
import FormControl from '../../components/Form/FormControl';

const Forms = () => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Row className="styles-section row" id="forms">
      <Col xs={12}>
        <h3>Forms</h3>
      </Col>
      <Col xs={12}>
        <Row>
          <Col xs={12}>
            <h6>Statuses</h6>
          </Col>
          <Col xs={12} sm={4}>
            <Form.Group>
              <Form.Label>Label Name</Form.Label>
              <FormControl type="text" placeholder="Text" />
            </Form.Group>
          </Col>

          <Col xs={12} sm={4}>
            <Form.Group>
              <Form.Label>Label Name</Form.Label>
              <FormControl type="text" placeholder="Text" />
              <Form.Text>
                <i className="fal fa-exclamation-triangle text-warning mr-2"></i>
                This is a warning label
              </Form.Text>
            </Form.Group>
          </Col>

          <Col xs={12} sm={4}>
            <Form.Group>
              <Form.Label>Label Name</Form.Label>
              <FormControl type="text" placeholder="Text" error />
              <Form.Text>
                <i className="fal fa-exclamation-circle text-danger mr-2"></i>
                This is a error label
              </Form.Text>
            </Form.Group>
          </Col>

          <Col xs={12} sm={4}>
            <Form.Group>
              <Form.Label>Label Name</Form.Label>
              <FormControl type="text" placeholder="Text" />
              <Form.Text>
                <i className="fal fa-check-circle text-success mr-2"></i>
                This is a success label
              </Form.Text>
            </Form.Group>
          </Col>

          <Col xs={12} sm={4}>
            <Form.Group>
              <Form.Label>Label Name</Form.Label>
              <FormControl type="text" placeholder="Text" />
              <Form.Text>
                <i className="fal fa-info-circle text-info mr-2"></i>
                This is a information label
              </Form.Text>
            </Form.Group>
          </Col>

          <Col xs={12} sm={4}>
            <Form.Group>
              <Form.Label>Label Name</Form.Label>
              <FormControl type="text" placeholder="Text" />
              <Form.Text>
                This is a regular label
              </Form.Text>
            </Form.Group>
          </Col>

          <Col xs={12} sm={4}>
            <InputGroup className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Text>@</InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl placeholder="Text" />
            </InputGroup>
          </Col>

          <Col xs={12} sm={4}>
            <InputGroup className="mb-3">
              <FormControl placeholder="Text" />
              <InputGroup.Append>
                <InputGroup.Text>.00</InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
          </Col>

        </Row>
      </Col>

      <Col xs={12}>
        <h6>Types of inputs</h6>
        <Row>
          <Col xs={12} sm={4}>
            <Form.Group>
              <Form.Label>Regular text</Form.Label>
              <FormControl type="text" placeholder="Text" />
            </Form.Group>
          </Col>

          <Col xs={12} sm={4}>
            <Form.Group>
              <Form.Label>Phone number</Form.Label>
              <FormControl type="tel" placeholder="Phone number" defaultValue={"(123)456-7889"} />
            </Form.Group>
          </Col>

          <Col xs={12} sm={4}>
            <Form.Group>
              <Form.Label>Password</Form.Label>
              <FormControl
                placeholder="Password"
                append={
                  <button className='btn'
                    onClick={() => setShowPassword(!showPassword)}>
                    {
                      showPassword
                        ? <i className="fal fa-eye-slash"></i>
                        : <i className="fal fa-eye"></i>
                    }
                  </button>
                }
                type={showPassword ? "text" : "password"}
                defaultValue="password"
              />
            </Form.Group>
          </Col>

          <Col xs={12} sm={4}>
            <Form.Group>
              <Form.Label>Label Name</Form.Label>
              <FormControl placeholder="Textarea" textarea />
            </Form.Group>
          </Col>

        </Row>
      </Col>

    </Row>
  );
};

export default Forms;